<template>
    <div class="app-container">
        <div class="div-align-lr page-top-but">
            <el-button type="primary" icon="el-icon-plus" @click.native="newAddpatrol">新增巡查团队</el-button>

            <div style="width=250px"><el-input placeholder="请输入内容" v-model="searchPatrolVal" class="input-with-select">
                <el-select v-model="searchPatrolSelectVal" slot="prepend" placeholder="请选择">
                    <el-option label="团队id" value="team_number"></el-option>
                    <el-option label="团队名称" value="team"></el-option>
                    <el-option label="队长" value="realname"></el-option>
                    <el-option label="联系方式" value="tel"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="onSearchPatrolBut"></el-button>
            </el-input></div>
        </div>

        <!-- 表格 -->
        <el-table :data="tableData" row-key="index" stripe style="width: 100%">
            <el-table-column align="center" type="index" label="序号" width="100"> </el-table-column>
            <el-table-column align="center" prop="team_number" label="团队id" sortable> </el-table-column>
            <el-table-column align="center" prop="name" label="团队名称" sortable> </el-table-column>
            <el-table-column align="center" prop="realname" label="队长" sortable> </el-table-column>
            <el-table-column align="center" prop="tel" label="联系方式"> </el-table-column>
            <el-table-column align="center" prop="area" label="管理区域"> </el-table-column>
            <el-table-column align="center" prop="u_number" label="成员人数" sortable> </el-table-column>
            <el-table-column align="center" prop="p_number" label="项目数" sortable> </el-table-column>

            <el-table-column align="center" label="操作" width="100">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row),drawer = true" slot="reference" type="text" size="small">查看</el-button>
                </template>
            </el-table-column>
        </el-table> 
        
        <div v-if="pageData.total > pageData.per_page" class="pageWrap">
            <el-pagination background layout="prev, pager, next" :page-size="pageData.per_page" :total="pageData.total" @current-change="handleCurrentChange"></el-pagination>
        </div>
        
        <addEditSmall :show="addPatrolShow" @onChange="onAddPatrolBoo" type="addTeam"></addEditSmall>
    </div>
</template>


<script>
import {apiXteamlistList,apiAddXteam,apiXteamdetailsList} from "../../api/views/patrol";
import addEditSmall from "./addEditSmall.vue";

export default {
    components: {
        addEditSmall
    },
    data() {
        return {
            query:{
                id: "",
                page: 1
            },
            pageData: {
                current_page: 1,
                last_page: 1,
                per_page: 1,
                total: 1
            },
            tableData: [],
            searchPatrolSelectVal: '',
            searchPatrolVal: '',
            addPatrolShow: false,
        }
    },
    mounted() {

    },
    created:function() {
        this.query.page = 1
        this.getList(this.query)
    },
    methods: {
        getList(query){
            const that = this
            apiXteamlistList(query).then(res => {
                console.log(res)
                this.tableData = res.data
                this.pageData = res
            }).catch(err => {
                console.log('获取列表-失败',err)
            })
        },
        newAddpatrol(){
            console.log('新建巡查团队')
            this.addPatrolShow = !this.addPatrolShow
            console.log(this.addPatrolShow)
        },
        onAddPatrolBoo(boo){
            console.log(boo)
            this.addPatrolShow = boo
        },
        onSearchPatrolBut(){
            console.log('搜索')
            this.query = {}
            this.query[this.searchPatrolSelectVal] = this.searchPatrolVal
            if(this.searchPatrolSelectVal && this.searchPatrolVal){
                this.getList(this.query)
                console.log(this.query)
            }else if(!this.searchPatrolSelectVal){
                this.$message({
                    message: '搜索类型不能为空',
                    type: "error"
                })
            }else if(!this.searchPatrolVal){
                this.$message({
                    message: '搜索内容不能为空',
                    type: "error"
                })
            }
        },
        handleClick(row){
            console.log('查看详情')
            this.$router.push({path:'details',query:{id:row.id}});
        },
        handleCurrentChange: function(currentPage){
            this.query.page = currentPage
            this.getList(this.query)
        },

    }
};
</script>


<style>
  .el-input-group__prepend .el-select{
    width: 120px;
  }
.page-top-but{
    padding:  20px;
}
  .pageWrap{
      padding: 30px 0;
      text-align: center;
  }
</style>